import { transitionMotorInsuranceDocumentsForm } from '../../../actions/motorPrivateRW/Documents';
import { FIELD_STATUS } from '../../../reducers/status';
import { getDocumentsForm } from '../../../selectors/motorPrivateRW/documents';
import { getSelectedCover } from '../../../selectors/motorPrivateRW/quote';

export const documentsFormRules = (store, next, action) => {
    const result = next(action);
    const shareQuoteForm = getDocumentsForm(store.getState());
    const selectedCover = getSelectedCover(store.getState());
    const quoteFormValid = validateDocumentsFormDetails(shareQuoteForm, selectedCover.value);
    const formAction = quoteFormValid
        ? transitionMotorInsuranceDocumentsForm.formValid()
        : transitionMotorInsuranceDocumentsForm.formInvalid();
    store.dispatch(formAction);

    return result;
};

const validateDocumentsFormDetails = (formFields, selectedCover) => {
    const isFieldValid = (field) => field && field.value !== null;

    if (selectedCover === "ThirdParty") {
        return (
            isFieldValid(formFields.idUpload) &&
            isFieldValid(formFields.yellowCard)
        );
    }

    // For other cover types, validate all required fields
    return (
        isFieldValid(formFields.idUpload) &&
        isFieldValid(formFields.yellowCard) &&
        isFieldValid(formFields.frontView) &&
        isFieldValid(formFields.backView) &&
        isFieldValid(formFields.leftView) &&
        isFieldValid(formFields.rightView) &&
        isFieldValid(formFields.dashboardView)
    );
};
